import { gql } from '@apollo/client';

export * from './appActiveProtectionIds.query.generated';

export const APP_ACTIVE_PROTECTION_IDS = gql`
  query appActiveProtectionIds($appId: ID!) {
    appProtections(appId: $appId, statuses: [active]) {
      id
    }
  }
`;
